import { useTranslation } from "@outschool/localization";
import { ApolloError } from "@outschool/ui-apollo";
import React from "react";

import SimpleLayout from "../components/layouts/SimpleLayout";
import StickyMobileHeader from "../components/nav/StickyMobileHeader";
import { NotFoundContent } from "../components/NotFoundContent";

type NotFoundPageProps = {
  data?: any;
  error?: string | ApolloError;
  title?: string;
  message?: React.ReactNode;
};

export default function NotFoundPage({
  data, // TODO: The structure of GraphQL data field may not be the same.
  error,
  title: titleProp,
  message
}: NotFoundPageProps) {
  const { t } = useTranslation("client\\routes\\NotFound");
  const title = titleProp ?? t`Whoops! That page doesn't exist.`;

  if (data && data.error && data.error.networkError) {
    return (
      <SimpleLayout narrowPaddedColumn>
        <StickyMobileHeader />
        <NotFoundContent data={data} title={title} message={message} />
      </SimpleLayout>
    );
  }

  return (
    <SimpleLayout error={error}>
      {/* @ts-ignore TS(2322): Type 'string | ApolloError | undefined' is not ass... Remove this comment to see the full error message */}
      <StickyMobileHeader error={error} />
      <NotFoundContent data={data} title={title} message={message} />
    </SimpleLayout>
  );
}
